'use strict';

var symbols = require('./constants').symbols;

module.exports = function getCurrencySymbol(currencyENUM) {
    return symbols[currencyENUM];
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/~/dibs-currency-helpers/getCurrencySymbol.js
// module id = 2653
// module chunks = 64